import { render, staticRenderFns } from "./TemplateDependencySection.vue?vue&type=template&id=d180887a"
import script from "./TemplateDependencySection.vue?vue&type=script&lang=js"
export * from "./TemplateDependencySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports